import { TableSelectionEvent } from "@mcleod/components";
import { MapSettings } from "@mcleod/core";
import { AutogenLayoutDispatchZoneList } from "./autogen/AutogenLayoutDispatchZoneList";
import { MapZoneSelectionUtil } from "./MapZoneSelectionUtil";
import { ZoneMapScreen } from "./MapZoneUtil";

export class DispatchZoneList extends AutogenLayoutDispatchZoneList {

    private mapVendor = MapSettings.getSingleton().getZoneMapVendor();
    private mapSelector: MapZoneSelectionUtil;

    override onLoad() {
        this.mainDataSource.search();
        this.mapSelector = new MapZoneSelectionUtil(this.mapVendor, this.mapRoute);
    }

    async tableDispatchZoneListOnSelect(event: TableSelectionEvent) {
        await this.mapSelector.handleRowSelection(ZoneMapScreen.DispatchZone, this.tableDispatchZoneList.selectedRow);
    }

}
